import React, { useState, useEffect, useContext } from 'react';
import {useTheme, makeStyles, Button} from '@material-ui/core';
import InputField from '../components/inputField';
import { makeValidation, validateForm, isValidForm} from '../global/formHelper';
import globalContext from '../context/globalContext';
import API from '../global/api';
import {localeCurrency, keyValueArray} from '../global/helpers';
import Alert from '@material-ui/lab/Alert';
import ProgressButton from '../components/progressButton';

const useStyles = makeStyles((theme) => ({
  detailsWrapper: {
    marginTop: 60,
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 40
  },
  utilityImage: {
    width: 300,
    height: 300,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden'
  },
}));

const UtilityEdit = props => {

  const theme = useTheme();
  const classes = useStyles(theme);
  const context = useContext(globalContext);

  const [ error, setError ] = useState(null);
  const [ loading, setLoading ] = useState(false);

  const [ serviceTypes, setServiceTypes ] = useState([]);
  const [ tariffs, setTariffs ] = useState([]);
  const [ pedestals, setPedestals ] = useState([]);

  const [ form, setForm ] = useState(props.data);

  const [validation, setValidation] = useState(makeValidation([
    {
      name: 'id_pedestal',
      display_name: 'Pedestal',
      required: true
    },
    {
      name: 'id_service_type',
      display_name: 'Utility Type',
      required: true
    },
    {
      name: 'utility_description',
      display_name: 'Description',
      required: false
    },
    {
      name: 'identity',
      display_name: 'Identity',
      required: false
    },
    {
      name: 'id_tariff',
      display_name: 'Tariff',
      required: true
    }
  ]));

  const handleInputChange = e => {
    let newForm = {...form};
    newForm[e.target.name] = e.target.value;
    setForm(newForm);
  }

  const handleSubmit = async () => {

    setError(null);
    setLoading(true);

    const valid = isValidForm(form, validation);
    setValidation(valid.validation);
    if(valid.isValid){


      //
      // Execute an api request and get the returned result
      //
      API.req(`/utility/${context.profile.data.id_organisation}`, 'PUT', form).then(
        async res => {
          setLoading(false);

          context.utilityUpdate(res.result);

          if(typeof props.handleClose === 'function')
            props.handleClose();

          context.showSnack({message: 'Utility updated!'}, 'success')

        },
        err => {
            setLoading(false);
            setError(typeof err === 'string' ? err : JSON.stringify(err))
        }
      )

    }
  }

  useEffect(() => {
    const newValidation = validateForm(form, validation);
    setValidation(newValidation);
  }, [form])


  useEffect(() => {
    let tariffs = [];
    context.tariffs.data.filter(t => t.deleted === null).forEach(t => {
      tariffs.push({
        key: t.id_tariff,
        value: `${t.tariff_name} ${localeCurrency(parseFloat(t.rate), t.currency)} / ${t.unit}`
      })
    })
    setTariffs(tariffs);
  }, [context.tariffs])


  useEffect(() => {
    let pedestals = [];
    context.pedestals.data.forEach(p => {
      pedestals.push({
        key: p.id_pedestal,
        value: p.pedestal_reference
      })
    })
    setPedestals(pedestals);
  }, [context.pedestals])

  useEffect(() => {
    
    if(typeof context.meta.data !== 'undefined' && typeof context.meta.data.service_types !== 'undefined')
      setServiceTypes(keyValueArray(context.meta.data.service_types, 'id_service_type', 'service_type'));

  }, [context.meta])


  return (
      <div className={classes.detailsWrapper}>
        {error && <Alert severity="error">{error}</Alert>}

        <div className={classes.form}>

          <div className="flex-row">
            <InputField name='id_pedestal' validation={validation.id_pedestal} value={form.id_pedestal} handleChange={handleInputChange} hoverLabel={true} type="select" items={pedestals} />
          </div>

          <div className="flex-row">
            <InputField name='id_service_type' validation={validation.id_service_type} value={form.id_service_type} handleChange={handleInputChange} hoverLabel={true} type="select" items={serviceTypes} />
          </div>

          <div className="flex-row">
            <InputField name='utility_description' validation={validation.utility_description} value={form.utility_description} handleChange={handleInputChange} hoverLabel={true} />
          </div>

          <div className="flex-row">
            <InputField name='identity' validation={validation.identity} value={form.identity} handleChange={handleInputChange} hoverLabel={true} />
          </div>

          <div className="flex-row">
            <InputField name='id_tariff' validation={validation.id_tariff} value={form.id_tariff} handleChange={handleInputChange} hoverLabel={true} type="select" items={tariffs} />
          </div>

        </div>

        <div className="flex"></div>

        <div className="flex-row-end">
          <ProgressButton waiting={loading} variant="contained" onClick={handleSubmit}>Save &amp; Close</ProgressButton>
        </div>

      </div>
  );
}

export default UtilityEdit;
